import { DataStore, Store } from "@xbs/muon";
import { IValue } from "@xbs/muon/dist/types/types";
import { getCellIds } from "../helpers/main";
import { IAction, IActionConfig } from "../types";

export class SortCells implements IAction {
	public config: IActionConfig;
	private _data: { [key: string]: [number, number, IValue][] };

	constructor(config: IActionConfig) {
		this.config = config;
		this._data = {};
	}

	do() {
		const { dir, cell, spreadsheet, page: activePage, dataStore , grid} = this.config;
		const cellsArr = cell.split(",");
		cellsArr.forEach(item => {
			let page = activePage;
			let c = item;
			if (c.includes("!")) {
				const parse = c.split("!");
				c = parse[1];
				page = dataStore.getPage(parse[0]);
				if (!page) return;
			}

			this._data[item] = page.serialize(true);
			const [rowsCount, colsCount] = page.getSize();
			const cellIds = getCellIds(c, grid);
			if (!cellIds.end) return;
			const { start, end } = cellIds;
			const topSplit = spreadsheet.config.topSplit;
			const startRow = topSplit || start.row;
			const lastRow = rowsCount - 1 < end.row ? rowsCount - 1 : end.row;
			const columnData = page.getCellRange(startRow, start.col, lastRow, start.col);
			const dataBeforeSort = [...columnData];
			const sortedColumn = columnData.sort((left, right) => {
				let a = left?.value;
				let b = right?.value;

				if (typeof a === "string") {
					a = a.toLowerCase();
				}

				if (typeof b === "string") {
					b = b.toLowerCase();
				}

				if (!a && typeof a !== "number" && b) {
					return 1;
				}
				if (!b && typeof b !== "number" && a) {
					return -1;
				}
				if (typeof a === "string" && typeof b === "number") {
					return -dir;
				}
				if (typeof a === "number" && typeof b === "string") {
					return dir;
				}
				if (a < b) {
					return -dir;
				}
				if (a > b) {
					return dir;
				}
				return 0;
			});
			let row = startRow;
			let index = 0;
			const sortedData = [];
			while (row < lastRow + 1) {
				const cell = sortedColumn[index];
				const prevRow = dataBeforeSort.indexOf(cell) + startRow;
				const gridRow = [];
				for (let col = 0; col < colsCount; col++) {
					const cellMeta = page.getCell(prevRow, col) || {};
					let cellValue = page.getValue(prevRow, col, true);
					if (typeof cellValue === "string" && cellValue.startsWith("=")) {
						cellValue = ((spreadsheet as any)._math as Store).transposeMath(
							cellValue,
							row - prevRow,
							0,
							page.getContext()
						);
					}
					gridRow.push([row, col, { ...cellMeta, value: cellValue }]);
				}

				sortedData.push(...gridRow);
				row++;
				index++;
			}
			const serializedData = page.serialize(true).filter(item => {
				const exsited = sortedData.find(d => d[0] === item[0] && d[1] === item[1]);
				return !exsited;
			});
			page.parse([...serializedData, ...sortedData]);
		});
		this.config.grid.paint();
	}

	undo() {
		const { grid, page: activePage, dataStore } = this.config;
		Object.keys(this._data).forEach(cell => {
			let page = activePage;
			if (cell.includes("!")) {
				const parse = cell.split("!");
				page = dataStore.getPage(parse[0]);
				if (!page) return;
			}
			page.parse(this._data[cell]);
		});
		grid.paint();
	}
}
